import React, { useState, useEffect } from 'react';
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import Select from "react-select";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getOperatorsForType, getInputType, EXCLUDED_TYPES, normalizeOperation } from '../../FormatDuplication/FormatDuplicationCondition/operatorsByType';

const TOKEN = document.querySelector("[name='csrf-token']")?.content;

const REFERENCE_TYPES = ['answer_user_id', 'proceso_id', 'position_id'];

export default function FormCreate({ isOpen, target, configuration_format_id, type_email, modeEdit, condition, onCreated, onUpdated, onClose, existingConditionsCount = 0, formatId, users, procesos, cargos }) {
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(
    modeEdit && condition ? { label: condition.question.question, value: condition.question.id, question_type: condition.question.question_type, options_values: condition.question.options } : null
  );
  const [operation, setOperation] = useState(modeEdit && condition ? normalizeOperation(condition.operation) : '');
  const [value, setValue] = useState(() => {
    if (!modeEdit || !condition) return '';
    const v = condition.value;
    if (v == null) return '';
    if (typeof v === 'object') return String(v.id || '');
    return String(v);
  });
  const [valueTo, setValueTo] = useState('');
  const [conditional, setConditional] = useState(modeEdit && condition ? (condition.conditional || 'Y') : 'Y');
  const [selectedValueOption, setSelectedValueOption] = useState(null);

  useEffect(() => {
    fetch(`/formatos/get_questions/${formatId}`, {
      method: 'GET', headers: { "X-CSRF-Token": TOKEN, "Content-Type": "application/json" }
    })
      .then(r => r.json())
      .then(data => {
        setQuestions(data.register
          .filter(q => !EXCLUDED_TYPES.includes(q.question_type))
          .map(q => ({ label: q.question, value: q.id, question_type: q.question_type, options_values: q.options }))
        );
      });
  }, [formatId]);

  useEffect(() => {
    if (!modeEdit || !condition) return;
    const op = normalizeOperation(condition.operation);
    if (op === 'entre' && condition.value && typeof condition.value === 'string') {
      const parts = condition.value.split(',');
      if (parts.length === 2) { setValue(parts[0]); setValueTo(parts[1]); }
    }
    if (selectedQuestion && REFERENCE_TYPES.includes(selectedQuestion.question_type)) {
      const condValue = typeof condition.value === 'object' ? condition.value?.id : condition.value;
      const opts = getRefOptions(selectedQuestion.question_type);
      const found = opts.find(o => String(o.value) === String(condValue));
      if (found) setSelectedValueOption(found);
    }
  }, []);

  const operators = selectedQuestion ? getOperatorsForType(selectedQuestion.question_type, { includeTodayOps: true }) : [];
  const inputType = selectedQuestion ? getInputType(selectedQuestion.question_type) : 'text';
  const questionType = selectedQuestion?.question_type || '';
  const isReference = REFERENCE_TYPES.includes(questionType);
  const isSelectType = ['answer_select', 'answer_radio'].includes(questionType);
  const isTodayOp = ['mayor_que_hoy', 'menor_que_hoy', 'igual_a_hoy'].includes(operation);

  const getRefOptions = (type) => {
    if (type === 'answer_user_id') return (users || []).map(u => ({ label: u.name, value: u.id }));
    if (type === 'proceso_id') return (procesos || []).map(p => ({ label: p.name, value: p.id }));
    if (type === 'position_id') return (cargos || []).map(c => ({ label: c.name, value: c.id }));
    return [];
  };

  const getSelectOptions = () => {
    if (!selectedQuestion?.options_values) return [];
    return selectedQuestion.options_values.map(o => typeof o === 'string' ? { label: o, value: o } : { label: o.name || o.label || o, value: o.name || o.label || o });
  };

  const handleQuestionChange = (opt) => {
    setSelectedQuestion(opt);
    setOperation('');
    setValue('');
    setValueTo('');
    setSelectedValueOption(null);
  };

  const handleSave = () => {
    if (!selectedQuestion || !operation) return;
    if (!isTodayOp && !isReference && !value && operation !== 'entre') return;

    const finalValue = operation === 'entre' ? `${value},${valueTo}` : value;
    const body = {
      configuration_format_id,
      type_email,
      question_id: selectedQuestion.value,
      operation,
      value: finalValue,
      conditional,
    };

    const url = modeEdit ? `/formatos/configuration_format_conditions/${condition.id}` : '/formatos/configuration_format_conditions';
    const method = modeEdit ? 'PATCH' : 'POST';

    fetch(url, { method, body: JSON.stringify(body), headers: { "X-CSRF-Token": TOKEN, "Content-Type": "application/json" } })
      .then(r => r.json())
      .then(data => {
        Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1500 });
        if (modeEdit && onUpdated) onUpdated(data.register);
        else if (onCreated) onCreated(data.register);
        onClose();
      });
  };

  const renderValueField = () => {
    if (isTodayOp) return null;

    if (isReference) {
      return (
        <div className="col-md-12 mb-2 p-0">
          <label>{questionType === 'answer_user_id' ? 'Usuario' : questionType === 'proceso_id' ? 'Proceso' : 'Cargo'}</label>
          <Select
            options={getRefOptions(questionType)}
            value={selectedValueOption}
            onChange={(opt) => { setSelectedValueOption(opt); setValue(String(opt.value)); }}
            placeholder="Seleccione..."
            className="link-form"
          />
        </div>
      );
    }

    if (isSelectType) {
      const opts = getSelectOptions();
      return (
        <div className="col-md-12 mb-2 p-0">
          <label>Valor</label>
          <Select
            options={opts}
            value={opts.find(o => o.value === value) || null}
            onChange={(opt) => setValue(opt.value)}
            placeholder="Seleccione..."
            className="link-form"
          />
        </div>
      );
    }

    if (operation === 'entre') {
      return (
        <div className="col-md-12 mb-2 p-0">
          <label>Rango</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input className="form-control form-control-sm" type={inputType} value={value} onChange={e => setValue(e.target.value)} placeholder="Desde" />
            <input className="form-control form-control-sm" type={inputType} value={valueTo} onChange={e => setValueTo(e.target.value)} placeholder="Hasta" />
          </div>
        </div>
      );
    }

    return (
      <div className="col-md-12 mb-2 p-0">
        <label>Valor</label>
        <input className="form-control form-control-sm" type={inputType} value={value} onChange={e => setValue(e.target.value)} placeholder="Valor a comparar..." />
      </div>
    );
  };

  return (
    <UncontrolledPopover isOpen={isOpen} trigger="legacy" placement="bottom" target={target} onClick={e => e.stopPropagation()}>
      <PopoverHeader>
        <div className='ui-modals-header-title__container'>
          <span className='ui-titles_modals'>
            {modeEdit ? "Editar condicion" : "Nueva condicion"}
            <a className="close-popover" onClick={onClose}><i className="fas fa-times" /></a>
          </span>
        </div>
      </PopoverHeader>
      <PopoverBody className="popover-column">
        <div className="col-md-12 p-0" style={{ width: 380, height: "auto" }}>
          {(existingConditionsCount > 0 || modeEdit) && (
            <div className="col-md-12 mb-2 p-0">
              <label>Conector logico</label>
              <select className="form-control form-control-sm" value={conditional} onChange={e => setConditional(e.target.value)}>
                <option value="Y">Y (AND)</option>
                <option value="O">O (OR)</option>
              </select>
            </div>
          )}

          <div className="col-md-12 mb-2 p-0">
            <label>Pregunta a evaluar</label>
            <Select options={questions} value={selectedQuestion} onChange={handleQuestionChange} placeholder="Seleccione..." className="link-form" />
          </div>

          {selectedQuestion && (
            <div className="col-md-12 mb-2 p-0">
              <label>Operador</label>
              <select className="form-control form-control-sm" value={operation} onChange={e => { setOperation(e.target.value); setValue(''); setValueTo(''); }}>
                <option value="">Seleccione...</option>
                {operators.map(op => <option key={op.value} value={op.value}>{op.label}</option>)}
              </select>
            </div>
          )}

          {selectedQuestion && operation && renderValueField()}

          <div className="col-md-12 p-0">
            <button className="btn-shadow btn btn-info btn-block" onClick={handleSave} disabled={!selectedQuestion || !operation}>
              {modeEdit ? "Actualizar" : "Agregar condicion"}
            </button>
          </div>
        </div>
      </PopoverBody>
    </UncontrolledPopover>
  );
}
